<template>
  <div class="staff-info">
    <div class="header text-center">
      <h1>{{ staff.class }}</h1>
    </div>
    <div class="row">
      <div
        class="col-lg-6 info-wrapper"
        v-for="(profile, index) in staff.profiles"
        :key="index"
      >
        <div
          class="item"
          :class="{ active: profile.isActive }"
          @click="selectProfile(profile)"
        >
          <div class="profile-img">
            <img :src="`/${$staticPath}/${profile.img}`" />
          </div>
          <div class="profile-content">
            <div class="name">
              <p>
                <b>{{ profile.name }}</b>
              </p>
            </div>
            <div class="max-edu">
              <p>{{ profile.position[profile.position.length - 1] }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['staff'],
  methods: {
    selectProfile: function (profile) {
      this.$emit('selectProfile', profile)
    }
  }
}
</script>

<style scoped>
  .staff-info .info-wrapper {
  margin-bottom: 15px;
  padding-left: 10px;
  padding-right: 10px;
}

.staff-info .item {
  position: relative;
  padding-top: 15px;
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: 15px;
  cursor: pointer;
  border-radius: 5px;
  border: 0.5px solid rgba(180, 180, 180, 0.1);
  box-shadow: 4px 5px 2px -2px rgba(255, 165, 0, 0.2);
  transition: 0.5s;
}

.staff-info .item:hover,
.staff-info .item.active {
  background-color: #ffa500;
  box-shadow: 0px 0px 4px 6px rgba(255, 165, 0, 0.5);
}

.staff-info .item p {
  line-height: 1.4;
  margin-bottom: 5px;
}

.staff-info .item:hover p {
  color: #fff;
}

.staff-info .item .profile-content {
  position: absolute;
  top: 50%;
  left: 110px;
  transform: translateY(-50%);
  width: calc(100% - 115px);
}

.profile-img {
  width: 90px;
  height: 90px;
}

.profile-img img {
  width: inherit;
  height: inherit;
  border-radius: 50%;
  float: left;
}

@media screen and (max-width: 480px) {
  .staff-info .item p {
    font-size: 14px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/STAFF/StaffInfo.vue